import { Route$PatternMatchedEvent } from "sap/ui/core/routing/Route";
import BaseController from "./BaseController";
import JSONModel from "sap/ui/model/json/JSONModel";
import { EnvironmentService } from "../service/Environment.service";
import { Link$PressEvent } from "sap/m/Link";
import ObjectPageLayout from "sap/uxap/ObjectPageLayout";
import HorizontalLayout from "sap/ui/layout/HorizontalLayout";
import { ErrorHandler } from "../service/ErrorHandler.service";
import { URLHelper } from "sap/m/library";
import Log, { Logger } from "sap/base/Log";

/**
 * @namespace com.unitrade.crm.controller
 */
export default class CustomerDetails extends BaseController {
  private _logger: Logger;
  private _title: string = "";
  private _customerModel: JSONModel;
  private _metaModel: JSONModel;
  private _latestBesuchsberichtModel: JSONModel;

  private _id: number;
  private _lfd: number;

  public override async getTitle(): Promise<string> {
    return await Promise.resolve(this._title);
  }

  async onInit(): Promise<void> {
    this._logger = Log.getLogger("com.unitrade.crm.controllers.CustomerDetails");
    this._customerModel = new JSONModel();
    this._metaModel = new JSONModel({ busy: false });
    this._latestBesuchsberichtModel = new JSONModel();
    this.setModel(this._customerModel, "Customer");
    this.setModel(this._latestBesuchsberichtModel, "Besuchsbericht");
    this.setModel(this._metaModel, "meta");
    const oOwnerComponent = this.getOwnerComponent();
    const oRouter = oOwnerComponent.getRouter();
    oRouter.getRoute("customersDetails").attachPatternMatched(this._onPatternMatch, this);

    this._showFormFragment("CustomerDisplay");
  }

  private async _showFormFragment(sFragmentName: string): Promise<void> {
    const oBox = this.byId("customer_details_header_form") as HorizontalLayout;
    oBox.removeAllContent();
    const pFormFragment = await this.getFragment(sFragmentName);
    oBox.insertContent(pFormFragment, 0);
  }

  onExit(): void {
    const oRouter = this.getOwnerComponent().getRouter();
    oRouter.getRoute("customersDetails").detachPatternMatched(this._onPatternMatch, this);
  }

  private _onPatternMatch = async (oEvent: Route$PatternMatchedEvent) => {
    this._metaModel.setProperty("/busy", true);

    const args = oEvent.getParameter("arguments") as {
      idPath: string;
      lfdPath: string;
    };
    this._id = Number(args.idPath);
    this._lfd = Number(args.lfdPath);

    try {
      this._customerModel.setData({});
      this._latestBesuchsberichtModel.setData(undefined);
      await this._customerModel.loadData(`${EnvironmentService.getBaseUrl()}/kunde/${this._id}/${this._lfd}`);
      try {
        await this._latestBesuchsberichtModel.loadData(`${EnvironmentService.getBaseUrl()}/besuchsbericht/kunde/${this._id}/${this._lfd}/latest`);
      } catch (ex: any) {
        this._logger.info(`No 'latest' visitreport found for customer ${this._id}/${this._lfd}`);
      }
    } catch (ex: any) {
      ErrorHandler.handleError(ex, { title: "Fehler beim Laden des Kunden", ignorable: false, onAbort: this.gotoCustomerList });
    } finally {
      this._metaModel.setProperty("/busy", false);
    }

    this._title = "Kunde";
    this.setTitle();
  };

  scrollToBesuchsbericht = (oEvent: Link$PressEvent) => {
    const layout = this.byId("customer-details-objectpagelayout") as ObjectPageLayout;
    layout.scrollToSection(this.byId("customer-details-object-page-section-besuchbericht").getId());
  };

  gotoCustomerList = () => {
    this.getRouter().navTo("customers");
  };

  phoneNumberPress = (oEvent: Link$PressEvent) => {
    const number = this._customerModel.getProperty("/telefonnummer1");
    URLHelper.triggerTel(number);
  };

  emailPress = (oEvent: Link$PressEvent) => {
    const number = this._customerModel.getProperty("/email");
    URLHelper.triggerEmail(number);
  };
}
